/* eslint-disable @typescript-eslint/naming-convention */
import { moduleRoutes as auth } from './auth-routes';
import { moduleRoutes as home } from './home-routes';
import { moduleRoutes as storeAdmin } from './store-admin';
import { moduleRoutes as reversions } from './reversions-routes';
import { moduleRoutes as transactions } from './transactions-routes';
import { moduleRoutes as search } from './search-query-routes';
import { moduleRoutes as txnInquiry } from './txn-inquiry-routes';
import { moduleRoutes as dashboards } from './dashboards-routes';

export const standardRoutes = {
  EMPTY: '',
  ANY: '**',
  HOME: 'homePage',
  DEFAULT: 'homePage',
  UNAUTHORIZED: 'unauthorized',
  NOTFOUND: 'notfound',
  LOGIN: 'universalLogin',
  OPENIDLOGIN: 'openidlogin',
  FORGETPASSWORD: 'forgetPassword',
  REQUESTPASSWORD: 'requestPassword',
  CHANGEPASSWORD: 'password',
  SESSIONBASED_HOME_NODEVICE: 'unknownDevice',
  SESSIONBASED_HOME_DEVICE: 'homeImage',
  SESSIONBASED_HOME: 'withdrawal',
  SESSIONLESS_HOME: 'universalLogin',
  REGISTER: 'registerUser',
};

export const formRoutes = {
  auth,
  dashboards,
  home,
  storeAdmin,
  reversions,
  search,
  transactions,
  txnInquiry,
};
